import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AnyIntegration, IIntegrationVistarMedia } from '../../../../interfaces/restaurant';

type EditIntegrationVistarForm = {
  proxy: FormControl<boolean>;
  proxyUnifiedMode: FormControl<boolean>;
  apiKey: FormControl<string>;
  networkId: FormControl<string>;
  venueId: FormControl<string>;
};

@UntilDestroy()
@Component({
  selector: 'app-edit-integration-vistar',
  templateUrl: './edit-integration-vistar.component.html',
  styleUrls: ['./edit-integration-vistar.component.scss']
})
export class EditIntegrationVistarComponent implements OnInit {

  @Input() set data(value: AnyIntegration) {

    if (value && value.provider === 'vistarMedia') {
      const vistarValue = value as IIntegrationVistarMedia;

      this.editIntegrationForm.get('proxy')?.setValue(vistarValue.proxy ?? false, { emitEvent: false });
      const proxyUnifiedModeControl = this.editIntegrationForm.get('proxyUnifiedMode');

      if (vistarValue.proxy) {
        proxyUnifiedModeControl?.enable({ emitEvent: false });
        proxyUnifiedModeControl?.setValue(vistarValue.proxyUnifiedMode ?? false, { emitEvent: false });
      } else {
        proxyUnifiedModeControl?.disable({ emitEvent: false });
        proxyUnifiedModeControl?.setValue(false, { emitEvent: false });
      }

      this.editIntegrationForm.patchValue(vistarValue.credentials);
    }
  }

  public editIntegrationForm: FormGroup<EditIntegrationVistarForm> = new FormGroup({
      proxy: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.required] }),
      proxyUnifiedMode: new FormControl(
        {value: false, disabled: true},
        { nonNullable: true, validators: [Validators.required] }
      ),
      apiKey: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.maxLength(255)] }),
      networkId: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.maxLength(255)] }),
      venueId: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.maxLength(255)] }),
    }
  );

  @Output() edited = new EventEmitter<Partial<AnyIntegration>>();
  @Output() remove = new EventEmitter<void>();

  constructor(
    public dialogRef: MatDialogRef<any>,
    public notifier: NotifierService,
  ) {}

  ngOnInit(): void {
    this.addListeners();
  }

  private addListeners(): void {
    this.editIntegrationForm.get('proxy')?.valueChanges.pipe(
      untilDestroyed(this)
    ).subscribe((proxyValue: boolean) => {
      const proxyUnifiedModeControl = this.editIntegrationForm.get('proxyUnifiedMode');

      if (!proxyValue) {
        proxyUnifiedModeControl?.disable({emitEvent: false});
        proxyUnifiedModeControl?.setValue(false, { emitEvent: false });
      } else {
        proxyUnifiedModeControl?.enable({emitEvent: false});
      }
    });
  }

  public edit(): void {
    const formValue = this.editIntegrationForm.getRawValue();

    this.edited.emit({
      proxy: formValue.proxy,
      proxyUnifiedMode: formValue.proxyUnifiedMode,
      credentials: {
        apiKey: formValue.apiKey,
        networkId: formValue.networkId,
        venueId: formValue.venueId
      }
    });
  }

  public removeIntegration(): void {
    this.remove.emit();
  }
}
